<template>
  <div class="container">
    <span class="goBack" @click="goBack()">Go Back to Lab</span>
    <div class="textInfo">
      <p>
        <span class="type">Sentences count:&nbsp;</span>
        <span class="count">{{sentencesCount}}</span>
      </p>&nbsp;|&nbsp;
      <p>
        <span class="type">Words count:&nbsp;</span>
        <span class="count">{{wordsCount}}</span>
      </p>&nbsp;|&nbsp;
      <p>
        <span class="type">Total length:&nbsp;</span>
        <span class="count">{{textAreaLength}}</span>&nbsp;
      </p>
    </div>
    <textarea
      class="textarea"
      :id="id"
      v-model="content"
      :rows="rows"
      :cols="cols"
      @input="handleInput"
    ></textarea>
  </div>
</template>

<script>
export default {
  name: "TextCalculator",
  props: {
    id: { type: String, default: "TextCalc-Area" },
    rows: { type: Number, default: 30 },
    cols: { type: Number, default: 200 },
  },
  data() {
    return {
      content: "",
      isComputed: false,
      textAreaLength: 0,
      wordsCount: 0,
      sentencesCount: 0,
    };
  },
  methods: {
    handleInput(e) {
      this.content = e.target.value;
      this.textAreaLength = e.target.value.length;
      this.wordsCount = e.target.value.split(" ").filter((el) => el).length;
      this.sentencesCount =
        e.target.value.match(/[\w\p{L}\p{M}|)][.?!\s](\s|$)/gimu)?.length || 0;
    },
    goBack() {
      window.location.href = "https://lab.pashinov.me/";
    },
  },
};
</script>

<style lang="less">
.container {
  display: inline-block;
  .goBack {
    float: left;
    display: block;
    position: absolute;
    font-size: 10px;
    cursor: pointer;

    &:hover {
      color: rgba(197, 197, 197, 0.85);
    }
  }
  .textInfo {
    display: flex;
    align-items: center;
    transition: all 1s ease-in-out;
    margin-top: 8px;
    .count {
      font-weight: bold;
      background-color: rgba(155, 155, 155, 0.85);
      color: rgba(6, 7, 13, 0.85);
      border-radius: 5px;
      padding: 3px;
    }
  }
  .textarea {
    width: calc(100% - 24px);
    border: 1px solid rgba(155, 155, 155, 0.85);
    background-color: rgba(6, 7, 13, 0.85);
    color: rgba(155, 155, 155, 0.85);
    font: normal 20px/1.4 "Open Sans", Helvetica, Arial, sans-serif;
    padding: 8px;
  }
}
</style>
